import { IconProps } from './Icon';

export const NewTabOutlineIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    color={color}
    height={height}
    viewBox="0 0 24 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g data-name="25. Open" id="_25._Open">
      <path d="m20 10v9a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1-1v-14a1 1 0 0 1 1-1h9a1 1 0 0 0 0-2h-9a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-9a1 1 0 0 0 -2 0z" />
      <path d="m21 2h-3a1 1 0 0 0 0 2h.59l-7.3 7.29a1 1 0 0 0 1.42 1.42l7.29-7.3v.59a1 1 0 0 0 2 0v-3a1 1 0 0 0 -1-1z" />
    </g>
  </svg>
);
